import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, ShieldCheck, TrendingUp, FileText, Landmark } from "lucide-react";
import { SERVICES } from "@/data/content";
import CtaBand from "@/components/CtaBand";

const ICONS = { insurance: ShieldCheck, "investment-mutual-funds": TrendingUp, "tax-gst": FileText, "banking-csc": Landmark };

export default function Services() {
  return (
    <>
      <section className="page-hero" data-testid="services-hero">
        <div className="eyebrow gold">Our Services</div>
        <h1>Everything money, <span className="accent">under one roof.</span></h1>
        <p>Char service verticals — protection, growth, compliance aur daily digital seva. Har service ka apna dedicated page hai.</p>
      </section>
      <section className="section">
        <div className="service-grid">
          {SERVICES.map((service, i) => {
            const Icon = ICONS[service.slug];
            return (
              <motion.article className={`service-card ${service.tone} tall`} key={service.slug} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.08 }} data-testid={`services-card-${service.slug}`}>
                <span className="chapter-no">0{i + 1}</span>
                <div className={`service-icon ${service.tone}`}><Icon size={22} /></div>
                <h3>{service.title}</h3>
                <small className="service-hindi">{service.hindi}</small>
                <p>{service.text}</p>
                <ul className="point-list">
                  {service.points.map((point) => <li key={point}>{point}</li>)}
                </ul>
                <Link to={`/services/${service.slug}`} data-testid={`services-link-${service.slug}`}>Open service page <ArrowUpRight size={15} /></Link>
              </motion.article>
            );
          })}
        </div>
      </section>
      <CtaBand />
    </>
  );
}
